var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaders = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M4.688 1.875a.937.937 0 0 0-.938.938v24.375c0 .517.42.937.938.937h22.5c.517 0 .937-.42.937-.937V2.813a.937.937 0 0 0-.937-.938zm-2.813.938A2.813 2.813 0 0 1 4.688 0h22.5A2.813 2.813 0 0 1 30 2.813v24.375A2.813 2.813 0 0 1 27.188 30h-22.5a2.813 2.813 0 0 1-2.813-2.812z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M11.25 6.563c0-.518.42-.938.938-.938a4.69 4.69 0 0 1 4.687 4.688v9.375a4.69 4.69 0 0 1-4.687 4.687.937.937 0 1 1 0-1.875A2.81 2.81 0 0 0 15 19.688v-9.375A2.81 2.81 0 0 0 12.188 7.5a.937.937 0 0 1-.938-.937",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M15.938 18.75c.517 0 .937.42.937.938a2.81 2.81 0 0 0 2.813 2.812.937.937 0 1 1 0 1.875A4.69 4.69 0 0 1 15 19.688c0-.518.42-.938.938-.938M16.373 6.998a4.7 4.7 0 0 1 3.314-1.373.937.937 0 1 1 0 1.875 2.81 2.81 0 0 0-2.812 2.813.937.937 0 1 1-1.875 0c0-1.244.494-2.436 1.373-3.315",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M11.25 17.813c0-.518.42-.938.938-.938h7.5a.937.937 0 1 1 0 1.875h-7.5a.937.937 0 0 1-.938-.937",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/headers.817c29f0.svg";